import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartPie,
    FaMapMarkedAlt,
    FaChartLine,
    FaUsers,
    FaHome,
    FaSyringe,
    FaClipboardList,
    FaUserMd
} from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import SummaryWrapper from './Summary';
import GeneralProductionWrapper from './GeneralProduction';
import StratifiedProductionWrapper from './StratifiedProduction';
import HouseHoldVisitWrapper from './HouseHoldVisit';
import VaccinationWrapper from './Vacination';
import ProceduresWrapper from './Procedures';
import ProfessionalsWrapper from './Professionals';
import MappingWrapper from './Mapping';

const menus = [
    {
        title: 'Resumo',
        path: '/governanceroom/dashboardesus/production/summary',
        icon: <FaChartPie style={{ marginRight: '5px' }} />
    },
    {
        title: 'Mapeamento',
        path: '/governanceroom/dashboardesus/production/mapping',
        icon: <FaMapMarkedAlt style={{ marginRight: '5px' }} />
    },
    {
        title: 'Prod. Geral',
        path: '/governanceroom/dashboardesus/production/general-production',
        icon: <FaChartLine style={{ marginRight: '5px' }} />
    },
    {
        title: 'Prod. Estratificada',
        path: '/governanceroom/dashboardesus/production/stratified-production',
        icon: <FaUsers style={{ marginRight: '5px' }} />
    },
    {
        title: 'Visita Domiciliar',
        path: '/governanceroom/dashboardesus/production/home-visit',
        icon: <FaHome style={{ marginRight: '5px' }} />
    },
    {
        title: 'Vacinação',
        path: '/governanceroom/dashboardesus/production/vaccination',
        icon: <FaSyringe style={{ marginRight: '5px' }} />
    },
    {
        title: 'Procedimentos',
        path: '/governanceroom/dashboardesus/production/procedures',
        icon: <FaClipboardList style={{ marginRight: '5px' }} />
    },
    {
        title: 'Profissionais',
        path: '/governanceroom/dashboardesus/production/professionals',
        icon: <FaUserMd style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardesus/production/summary':
        'Resultados Gerais dos Indicadores de Atendimento',
    '/governanceroom/dashboardesus/production/mapping':
        'Mapa da Unidades de Saúde',
    '/governanceroom/dashboardesus/production/general-production':
        'Resultados Gerais da Produção Geral',
    '/governanceroom/dashboardesus/production/stratified-production':
        'Resultados Gerais da Produção Estratificada',
    '/governanceroom/dashboardesus/production/home-visit':
        'Resultados Gerais das Visitas Domiciliares',
    '/governanceroom/dashboardesus/production/vaccination':
        'Resultados Gerais da Vacinação',
    '/governanceroom/dashboardesus/production/procedures':
        'Resultados Gerais dos Procedimentos',
    '/governanceroom/dashboardesus/production/professionals':
        'Resultados Gerais dos Profissionais'
};

const Production = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardesus');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                    showServiceTypesStratified={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/stratified-production'
                    }
                    showServiceTypesProfessionals={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/professionals'
                    }
                    showHouseholdStatus={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/home-visit'
                    }
                    showImmunobiologicals={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/vaccination'
                    }
                    showImmunobiologicalsDoses={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/vaccination'
                    }
                    showProcedureGroup={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/procedures'
                    }
                    showProcedureSubgroup={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/procedures'
                    }
                    showProcedures={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/procedures'
                    }
                    showCbo={
                        location.pathname ===
                        '/governanceroom/dashboardesus/production/professionals'
                    }
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="summary" replace />}
                        />
                        <Route path="summary" element={<SummaryWrapper />} />
                        <Route path="mapping" element={<MappingWrapper />} />
                        <Route
                            path="general-production"
                            element={<GeneralProductionWrapper />}
                        />
                        <Route
                            path="stratified-production"
                            element={<StratifiedProductionWrapper />}
                        />
                        <Route
                            path="home-visit"
                            element={<HouseHoldVisitWrapper />}
                        />
                        <Route
                            path="vaccination"
                            element={<VaccinationWrapper />}
                        />
                        <Route
                            path="procedures"
                            element={<ProceduresWrapper />}
                        />
                        <Route
                            path="professionals"
                            element={<ProfessionalsWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Production;
